import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsDatePicker',
  props: {
    date: null,
    accentColor: null,
    label: null,
    error: { type: Boolean },
    errorMessages: null,
    rules: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  date?: string
  accentColor?: string
  label?: string
  error?: boolean
  errorMessages?: string[]
  rules?: (() => string | boolean)[]
};





const date = computed({
  get: () => props.date || '',
  set: (value) => emit('change', value || ''),
})

const error = computed(
  () => props.error || false || errorMessages.value.length > 0,
)

const errorMessages = ref<string[]>(props.errorMessages || [])

onMounted(() => {
  if (props.rules) {
    props.rules.forEach((rule) => {
      //errorMessages.value.push(rule());
      const result = rule()
      if (typeof result === 'string') {
        errorMessages.value.push(result)
      }
    })
  }
})

watch(date, (newDate) => {
  emit('change', newDate || '')
})

const handleInputClick = (evt: MouseEvent) => {
  try {
    const target = evt.currentTarget as HTMLInputElement
    target.showPicker()
  } catch (error) {
    console.error(error)
  }
}

const handleWrapperClick = (evt: MouseEvent) => {
  if ((evt.currentTarget as HTMLElement).children.length > 1) {
    ;(
      (evt.currentTarget as HTMLElement).children[1] as HTMLInputElement
    ).focus()
  }
}

function handleInputChange(evt: Event) {
  const target = evt.currentTarget as HTMLInputElement
  date.value = target.value
}

return { __sfc: true,props, emit, date, error, errorMessages, handleInputClick, handleWrapperClick, handleInputChange }
}

})